var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Watch, Utils, PropertyConverters, Components, CommandEvent } from '@pacem/pacem-core';
import { DialogButton } from './dialog-abstractions';
//namespace Pacem.Components.UI {
let PacemButtonElement = class PacemButtonElement extends Components.PacemIterableElement {
    constructor() {
        super('button');
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.hasAttribute('tab-order')) {
            this.tabOrder = 0;
        }
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'iconGlyph':
            // suppose ligatures enabled
            case 'iconUrl':
                // handle this via css attr(), considering that it's the proper way to access and modify pseudo::before content
                this.dataset[name] = val;
                break;
        }
    }
    emit(evt) {
        let fn = (ev) => {
            super.emit(ev);
            if (!ev.defaultPrevented) {
                if (ev.type === 'click' && !Utils.isNullOrEmpty(this.commandName)) {
                    this.dispatchEvent(new CommandEvent({ commandName: this.commandName, commandArgument: this.commandArgument }));
                }
                else {
                    switch (ev.type) {
                        case 'mousedown':
                            if (evt.button === 0) {
                                Utils.addClass(this, PCSS + '-active');
                            }
                            break;
                        case 'keydown':
                            if (ev.keyCode === 32 || ev.keyCode === 13) {
                                evt.preventDefault();
                                Utils.addClass(this, PCSS + '-active');
                            }
                            break;
                        case 'blur':
                        case 'mouseup':
                            Utils.removeClass(this, PCSS + '-active');
                            break;
                        case 'keyup':
                            if (ev.keyCode === 32 || ev.keyCode === 13) {
                                this.click();
                                Utils.removeClass(this, PCSS + '-active');
                            }
                            break;
                    }
                }
            }
        };
        if (!this.disabled && evt.type === 'click' && !Utils.isNull(this.confirmationDialog)) {
            this.confirmationDialog.open(this.confirmationMessage).then(r => {
                if (r.button === DialogButton.Yes || r.button === DialogButton.Ok)
                    fn(evt);
            });
        }
        else if (!(evt instanceof MouseEvent) || evt.button === 0) {
            fn(evt);
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemButtonElement.prototype, "iconGlyph", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemButtonElement.prototype, "iconUrl", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemButtonElement.prototype, "commandName", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemButtonElement.prototype, "commandArgument", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemButtonElement.prototype, "confirmationMessage", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemButtonElement.prototype, "confirmationDialog", void 0);
PacemButtonElement = __decorate([
    CustomElement({
        tagName: P + '-button'
    })
], PacemButtonElement);
export { PacemButtonElement };
//}
